<!--
 * @FileDescription: 单据——采购入库详情
 * @Author: ryb
 * @Date: 2020-07-22
 -->
<template>
  <div class="bill-purchase-page">
    <div class="bill-purchase-information" id="page-top">
      <a-row class="ant-row-one">
        <a-col :span="12"></a-col>
        <a-col style="display:flex;justify-content: flex-end;" :span="12">
          <a-col>
            <span class="a-col-title">单据单号：</span>
            <span class="a-col-value"> {{ dataDetails.purchaseOrderVo.code }}</span>
          </a-col>
          <a-col style="margin-left: 106px">
            <span class="a-col-title">单据日期：</span>
            <span class="a-col-value"> {{ dataDetails.purchaseOrderVo.orderDate }}</span>
          </a-col>
        </a-col>
      </a-row>
      <a-row class="ant-row-two">
        <a-col>
          <span class="a-col-title">往来单位：</span>
          <span class="a-col-value"> {{ dataDetails.purchaseOrderVo.contactCustomerName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">入库仓库：</span>
          <span class="a-col-value"> {{ dataDetails.purchaseOrderVo.inStorageName }}</span>
        </a-col>
        <a-col v-if="dataDetails.purchaseOrderVo.transactorName">
          <span class="a-col-title">经办人：</span>
          <span class="a-col-value"> {{ dataDetails.purchaseOrderVo.transactorName }}</span>
        </a-col>
        <a-col v-if="dataDetails.purchaseOrderVo.digest">
          <span class="a-col-title">摘要：</span>
          <span class="a-col-value"> {{ dataDetails.purchaseOrderVo.digest }}</span>
        </a-col>
        <a-col v-if="dataDetails.purchaseOrderVo.remark">
          <span class="a-col-title">备注：</span>
          <span class="a-col-value"> {{ dataDetails.purchaseOrderVo.remark }}</span>
        </a-col>
        <a-col>
          <look-popover :type="3" :dataDetails="dataDetails">
            <span class="border-color" slot="trigger-tag">
              更多
              <a-icon type="right-circle" style="margin-left: 3px" />
            </span>
          </look-popover>
        </a-col>
      </a-row>
    </div>
      <div class="line"></div>
    <div class="bill-purchase-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataDetails.purchaseOrderItemVOList" :pagination="false" rowKey="productCode" :scroll="{x:1000, y: (tableHeight) }" bordered>
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{ index+1 }}</span>
        </template>
        <!-- 商品名称 -->
        <template slot="productName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px" v-if="record.giftFlag==1">
              <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品编号 -->
        <template slot="productCode" slot-scope="text">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品备注 -->
        <template slot="remark" slot-scope="text">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <template slot="footer">
          <div class="footer-total-amount">
            <div class="footer-total-amount-left" style="width: 80px">
              <span class="title">小计</span>
            </div>
            <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
              <span class="right-col">数量：{{ footerDataSource[0].productTotalCount }}</span>
              <span class="right-col">金额：{{ footerDataSource[0].totalAmount.toFixed(2) }}</span>
            </div>
          </div>
        </template>
      </a-table>
    </div>
    <!-- 底部按钮组件 -->
    <public-footer :buttonList="buttonList"></public-footer>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import publicFooter from '@/components/module/publicFooter.vue'
import lookPopover from "./modules/lookPopover.vue"
import { tableWidth } from "@/mixins/tableWidth"
import { getDetailsMethod } from "@/utils/api"
export default {
  name: 'purchaseOrderLook',
  mixins: [tableWidth],
  components: {
    publicFooter,
    lookPopover,
  },
  data () {
    return {
      columns: [
        {
          width: 80,
          title: "序号",
          align: "center",
          dataIndex: "serialNum",
          ellipsis: true,
          scopedSlots: { customRender: "serialNum" },
        },
        {
          defaultWidth: 200,
          title: "商品名称",
          dataIndex: "productName",
          ellipsis: true,
          scopedSlots: { customRender: "productName" },
        },
        {
          defaultWidth: 200,
          title: "商品编号",
          dataIndex: "productCode",
          ellipsis: true,
          scopedSlots: { customRender: "productCode" },
        },
        {
          title: "规格",
          ellipsis: true,
          dataIndex: "productSpecification",
        },
        {
          title: "型号",
          ellipsis: true,
          dataIndex: "productModel",
        },
        {
          defaultWidth: 70,
          title: "单位",
          ellipsis: true,
          dataIndex: "productUnitName",
        },
        {
          title: "数量",
          dataIndex: "productTotalCount",
          ellipsis: true,
          scopedSlots: { customRender: "productTotalCount" },
        },
        {
          title: "单价",
          align: "right",
          dataIndex: "price",
          ellipsis: true,
          scopedSlots: { customRender: "price" },
        },
        {
          title: '已入库数量',
          align: "right",
          ellipsis: true,
          dataIndex: 'inboundCount',
        },
        {
          title: '未入库数量',
          align: "right",
          ellipsis: true,
          dataIndex: 'noInboundCount'
        },
        {
          title: '金额',
          align: "right",
          ellipsis: true,
          dataIndex: 'totalAmount'
        }, 
        {
          defaultWidth: 180,
          title: "备注",
          dataIndex: "remark",
          ellipsis: true,
          scopedSlots: { customRender: "remark" },
        }
      ],
      dataSource: [],
      buttonList: [
        {
          id: 7,
          has: 'purchase_order_print',
          text: '打印',
          templateType: 204
        }
      ],
      footerDataSource: [{
        serialNum: '',
        productName: '',
        productCode: '',
        productSpecification: '',
        productModel: '',
        productUnit: '',
        productCount: 0,
        price: '',
        totalAmount: 0,
        locationName: '',
        remark: ''
      }],
      contentHeight:'',
      tableHeight: '',
      billPurchaseId: null,
      urlList: {
        details: '/order/api/purchaseOrder/findPurchaseOrderItemById'
      },
      accountsName: null,
      dataDetails: {
        purchaseOrderVo: {},
        purchaseOrderItemVOList: []
      },
      purchaseId:null
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.purchaseId = to.query.id
    this.init()
    this.getMakeDetails()
    next()
  },
  activated () {
    this.purchaseId = this.$route.query.id
    this.init()
    this.getMakeDetails()
  },
  methods: {
    init () {
      // 表格高度计算
      let _that = this
      setTimeout(function() {
        let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
        let header = document.getElementById("header").offsetHeight;
        let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
        let pageHeight = document.getElementById('content').offsetHeight
        let makeTop = document.getElementById('page-top').offsetHeight
        _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight * 0.96
        _that.tableHeight = _that.contentHeight - tdHeight * 2
      }, 50)
    },
    getMakeDetails () {
      let params = new FormData()
      params.append("id", this.purchaseId)
      this.$store.state.isLoding = true
      getDetailsMethod(this.urlList.details, params).then((res) => {
        if (res.code == 200) {
          this.footerDataSource[0].productTotalCount = 0
          this.footerDataSource[0].totalAmount = 0
          res.result.purchaseOrderItemVOList.map(item =>{
            item.totalAmount = item.productTotalCount * item.price
            this.footerDataSource[0].productTotalCount += item.productTotalCount
            this.footerDataSource[0].totalAmount += item.totalAmount
          })
          this.dataDetails = res.result
          this.$store.state.isLoding = false
        } else {
          this.$message.error(res.logMessage)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.bill-purchase-page {
  .bill-purchase-information {
    padding: 15px 40px;
    background-color: #ffffff;
    .ant-row-one {
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
    }
    .ant-row-two {
      padding: 8px 0;
      display: flex;
      flex-wrap: wrap;
      .ant-col {
        padding-right: 80px;
      }
    }
    .border-color {
      color: #f76f14;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .bill-purchase-table {
    background-color: #ffffff;
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 0 10px !important;
          height: 54px;
        }
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
        .text-overflow {
          width: 100%;
          height: 36px;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .ant-table-footer {
      padding: 0 5px 0 0;
      td:last-child {
        border-right: 0 !important;
      }
      .ant-table-body {
        border: 0;
      }
    }
  }
  .bill-purchase-price {
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 0 40px;
    margin-top: 16px;
    .logistics-information {
      height: 132px;
      padding: 24px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .ant-row {
        display: flex;
      }
    }
    .price-information {
      height: 132px;
      padding: 24px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .ant-row {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        .ant-col {
          margin-left: 42px;
        }
        .price-color {
          font-size: 16px;
          color: #f76f14;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
